export class Delegate
{
    public FirstName:string;
    public LastName:string;
    public TCKN:string;
    public PhoneNumber:string;
    public Email:string;
    public KepAddress:string;
    public IsMutabakat:boolean;
    public IsLedger:boolean;


}